import React from 'react';
import '../Aboutus/About-post.css';

const AboutPost = () => {
  return (
    <section className="about-post">
      <div className="overlay">
        <div className="about-content">
          <div className="about-left">
            <h1>About<br/> (Company Name)</h1>
          </div>
          <div className="about-right">
            <p>
(Company Name) is your trusted travel partner, offering seamless tour planning and unforgettable experiences. We make your journeys smooth, safe, and full of memories.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPost;
